(function () {
  const COZE_TOKEN = "pat_EUPLa6eCPCS7AtkPn3EImyrWq64wXLVj07ZgTf1uhEiDownq5L65bnawaRjW548S";
  const BOT_ID = "7485764607655690245";
  const USER_ID = "shopify_user_" + Math.random().toString(36).substring(2);
  let User_IP = null;
  fetch("https://api.ipify.org?format=json")
  .then(res => res.json())
  .then(data => {
    User_IP = data.ip;
    console.log("User IP:", User_IP);
  });

  let abortController = null;
  let currentBotDiv = null;

  const style = document.createElement("style");
  style.innerHTML = `
    #chat-toggle {
      position: fixed; bottom: 20px; right: 20px;
      background-color: #2d3e50; color: white;
      padding: 10px 16px; border-radius: 12px;
      border: none; cursor: pointer;
      z-index: 10000; font-size: 15px;
      display: flex; align-items: center; gap: 6px;
    }
    #chat-popup {
      position: fixed; bottom: 70px; right: 20px;
      width: 320px; height: 480px;
      background: #fff; border-radius: 12px;
      box-shadow: 0 4px 16px rgba(0,0,0,0.2);
      display: none; flex-direction: column;
      z-index: 10000; font-family: Arial, sans-serif;
    }
    #chat-header {
      background-color: #2d3e50; color: white;
      padding: 12px; font-size: 16px;
      display: flex; justify-content: space-between; align-items: center;
    }
    #chat-close { cursor: pointer; font-size: 18px; }
    #chat-messages {
      flex: 1; padding: 10px; overflow-y: auto;
      background: #f9f9f9;
    }
    #chat-input {
      display: flex; border-top: 1px solid #ccc;
    }
    #chat-input input {
      flex: 1; border: none; padding: 10px;
      outline: none;
    }
    #chat-input button {
      border: none; background: #007bff;
      color: white; padding: 10px 15px;
      cursor: pointer;
    }
    #cancel-btn {
      background: transparent; border: none;
      color: #888; font-size: 12px;
      text-align: center; cursor: pointer; padding: 4px;
    }
  `;
  document.head.appendChild(style);

  const toggle = document.createElement("button");
  toggle.id = "chat-toggle";
  toggle.innerHTML = "Rheida";
  document.body.appendChild(toggle);

  const popup = document.createElement("div");
  popup.id = "chat-popup";
  popup.innerHTML = `
    <div id="chat-header">
      Chat with us
      <span id="chat-close">×</span>
    </div>
    <div id="chat-messages">
      <div><strong>Rheida:</strong> 👋 Hi there! How can I help you?</div>
    </div>
    <button id="cancel-btn">Cancel current response</button>
    <div id="chat-input">
      <input type="text" id="user-input" placeholder="Write message" />
      <button id="send-btn">➤</button>
    </div>
  `;
  document.body.appendChild(popup);

  toggle.onclick = () => popup.style.display = "flex";
  document.getElementById("chat-close").onclick = () => popup.style.display = "none";
  document.getElementById("cancel-btn").onclick = cancelChat;


  async function sendMessageStreaming(messageText) {
    appendMessage("You", messageText);
    abortController = new AbortController();
    currentBotDiv = appendMessage("Rheida", "...");
  
    const res = await fetch("https://api.coze.com/v3/chat", {
      method: "POST",
      headers: {
        "Authorization": "Bearer " + COZE_TOKEN,
        "Content-Type": "application/json",
        "Accept": "text/event-stream"
      },
      body: JSON.stringify({
        bot_id: BOT_ID,
        user_id: USER_ID,
        stream: true,
        auto_save_history: true,
        metadata: User_IP ? { ip_address : User_IP } : undefined,
        additional_messages: [
          {
            role: "user",
            content: messageText,
            content_type: "text"
          }
        ]
      }),
      signal: abortController.signal
    });
  
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    let botMsg = "";
  
    try {
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
  
        buffer += decoder.decode(value, { stream: true });
        const events = buffer.split("\n\n");
        buffer = events.pop(); // 保留不完整的事件块
  
        for (const eventChunk of events) {
          const lines = eventChunk.split("\n");
          const eventType = lines.find(l => l.startsWith("event:"))?.slice(6).trim();
          const dataLine = lines.find(l => l.startsWith("data:"))?.slice(5).trim();
          if (!eventType || !dataLine) continue;
  
          try {
            const data = JSON.parse(dataLine);
            const chunk = data?.content;
            if (data?.type === "answer" && typeof data?.content === "string") {
              if (eventType === "conversation.message.delta") {
                botMsg += data.content;
                updateBotResponse(botMsg, data.content_type); // 👈 加上类型
              } else if (eventType === "conversation.message.completed") {
                botMsg = data.content;
                updateBotResponse(botMsg, data.content_type);
              }
            }
          } catch (e) {
            // console.warn("JSON parse failed on data:", dataLine);
          }
        }
      }
    } catch (error) {
      if (error.name === "AbortError") {
        currentBotDiv.innerHTML = "<strong>Bot:</strong> ❌ Chat was cancelled.";
      } else {
        currentBotDiv.innerHTML = "<strong>Bot:</strong> ⚠️ Error: " + error.message;
      }
    }
  
    currentBotDiv = null;
    abortController = null;
  }



  function cancelChat() {
    if (abortController) {
      abortController.abort();
    }
  }

  function appendMessage(sender, text) {
    const box = document.getElementById("chat-messages");
    const div = document.createElement("div");
    div.innerHTML = `<strong>${sender}:</strong> ${text}`;
    div.style.margin = "8px 0";
    box.appendChild(div);
    box.scrollTop = box.scrollHeight;
    return div;
  }

  function updateBotResponse(text) {
    if (currentBotDiv) {
      currentBotDiv.innerHTML = `<strong>Rheida:</strong> ${text}`;
      const box = document.getElementById("chat-messages");
      box.scrollTop = box.scrollHeight;
    }
  }

  // function updateBotResponse(content, contentType = "text") {
  //   if (!currentBotDiv) return;
  
  //   let html = "";
  
  //   if (contentType === "object_string") {
  //     try {
  //       const blocks = JSON.parse(content); // ⚠️ 这里的 content 是字符串形式的 JSON array
  //       for (const block of blocks) {
  //         if (block.type === "text") {
  //           html += `<div style="margin: 4px 0;">${block.text}</div>`;
  //         } else if (block.type === "image") {
  //           html += `<div style="margin: 6px 0;"><img src="${block.file_url}" style="max-width: 100%; border-radius: 8px;" /></div>`;
  //         } else if (block.type === "file") {
  //           html += `<div><a href="${block.file_url}" target="_blank">📎 Download file</a></div>`;
  //         }
  //       }
  //     } catch (err) {
  //       html = "<i>⚠️ Failed to parse rich content</i>";
  //     }
  //   } else {
  //     // 普通文本
  //     html = content;
  //   }
  
  //   currentBotDiv.innerHTML = `<strong>Bot:</strong> ${html}`;
  //   document.getElementById("chat-messages").scrollTop = document.getElementById("chat-messages").scrollHeight;
  // }


  document.getElementById("send-btn").onclick = () => {
    const input = document.getElementById("user-input");
    const msg = input.value.trim();
    if (!msg) return;
    input.value = "";
    sendMessageStreaming(msg);
  };

  document.getElementById("user-input").addEventListener("keydown", function (e) {
    if (e.key === "Enter") document.getElementById("send-btn").click();
  });
})();
